import _ from 'lodash';
import IApplicationState from 'app/types/state';

export function getCurrentReceipt(state: IApplicationState) {
  if (
    state.receipts.receiptsById !== undefined
    && state.receipts.currentReceiptId !== undefined
  ) {
    return state.receipts.receiptsById[
      state.receipts.currentReceiptId
    ];
  }
  return {};
}

export function getCurrentFormReceipt(state: IApplicationState) {
  return {
    ...getCurrentReceipt(state),
    ...state.receipts.requestedData,
  };
}

export function getReceipts(state: IApplicationState) {
  return {
    ...state.receipts,
    currentReceipt: {
      ...getCurrentReceipt(state),
    },
  };
}

export function getReceiptsByTeamId(
  state: IApplicationState,
  teamId,
) {
  if (
    state.receipts.receiptsById !== undefined
    && teamId != null
  ) {
    return _.filter(state.receipts.receiptsById, {
      teamId,
    });
  }
  return {};
}

export function getReceiptIdsByTeamId(
  state: IApplicationState,
  teamId,
) {
  if (
    state.receipts.receiptsById !== undefined
    && teamId != null
  ) {
    const filtered = _.filter(state.receipts.receiptsById, {
      teamId,
    });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}

export function getReceiptIdsByPaymentId(
  state: IApplicationState,
  paymentId,
) {
  if (
    state.receipts.receiptsById !== undefined
    && paymentId != null
  ) {
    const { receiptsById } = state.receipts;
    const filtered = _.filter(receiptsById, {
      payment: { id: paymentId },
    });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}
